import React, { useEffect, useState } from 'react'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import useTraeDatos from '../hooks/useTraeDatos';
import { traeIdNombre, existeRegistro, recibeImagen, errores } from '../hooks/Funciones'
import fotoVacia from '../../paginas/img/fotoVacia.jpg'
import moment from 'moment'


const SubirEditReglas = ({ baseUrl, data, setData, setFuncion, urlIngresos, registroSelect, TituloBtn, funcion }) => {

	const [registro, setRegistro] = useState(funcion === 'editar' ? registroSelect : { activo: true, ids_tipoingresos: [], imagePrev: fotoVacia })
	const [error, setError] = useState({ activo: false })

	//Consulta para subir o crear los datos 

	const creaFormData = (registro, METHOD) => {

		let { id, nombre, precio, minimo, maximo} = registro

		let f = new FormData()
		f.append('id', id)
		f.append('nombre', nombre)
		f.append('minimo', minimo)
		f.append('maximo', maximo)
		f.append('precio', precio)
		f.append('METHOD', METHOD)

		return f
	}

	const peticionPost = async () => {

		let { nombre, precio, minimo, maximo } = registro

		if (!existeRegistro(data, nombre)) {
			if (nombre !== undefined && precio !== undefined && minimo !== undefined && maximo !== undefined) {

				let f = creaFormData(registro, 'POST')
				await axios.post(baseUrl, f)

					.then(response => {
						console.log('result', response.data)
						let resultFormat = { ...response.data }
						setData([resultFormat, ...data])
						setRegistro({ activo: false })
						errores('Limpio', setError)
						setFuncion('ver')

					}).catch(error => {
						console.log(error);
					})
			} else errores('CampoVacio', setError)
		} else errores('Existe', setError)

	}

	const ProcedimientoPut = async () => {

		let { id, nombre, precio, minimo, maximo } = registro

		let f = creaFormData(registro, 'PUT')
		console.log('editado', registro)
		await axios.post(baseUrl, f)
			.then(response => {

				console.log(response.data)
				let dataNueva = data
				dataNueva.map(item => {
					if (item.id === id) {
						item.nombre = nombre
						item.precio = precio
						item.minimo = minimo
						item.maximo = maximo
					}
				})
				setData(dataNueva)
				console.log('enviado')
				errores('Limpio', setError)
			}).catch(error => {
				console.log('muestra erro: ' + error);
			})
		setFuncion('ver')
	}

	const peticionPut = () => {
		let {id, nombre, precio, minimo, maximo } = registro
		if (nombre !== '' && precio !== '' && minimo !== '' && maximo !== '') {
			ProcedimientoPut()
		} else errores('CampoVacio', setError)
	}


	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					{error.activo ? <span className="error"> Error: {error.mensaje}</span> : null}
					<div><hr />

						<div className='row'>
							<div className='col-md-12'>
								<MDBInput
									label="Nombre de la Regla de Envio" name="nombre" required className={error.nombre ? "form-control is-invalid" : null} outline
									value={registro.nombre}
									onChange={e => setRegistro({ ...registro, nombre: e.target.value })}
								/>

								<div className="row">
									<div className='col-md-4'>
										<MDBInput
											label="Precio de la Regla de Envio" name="precio" required className={error.precio ? "form-control is-invalid" : null} outline
											value={registro.precio}
											onChange={e => setRegistro({ ...registro, precio: e.target.value })}
										/>
									</div>
									<div className='col-md-4'>
										<MDBInput label="Valor Mínimo" name="minimo" required className={error.campoClave ? "form-control is-invalid" : null} outline
											value={registro.minimo}
											onChange={e => setRegistro({ ...registro, minimo: e.target.value })}
										/>
									</div>
									<div className='col-md-4'>
										<MDBInput label="Valor Máximo" name="maximo" required className={error.campoClave ? "form-control is-invalid" : null} outline
											value={registro.maximo}
											onChange={e => setRegistro({ ...registro, maximo: e.target.value })}
										/>
									</div>
								</div>

							</div>
						</div>

						<br />
						<div className="col text-center">
							<button onClick={funcion === 'editar' ? peticionPut : peticionPost} className="btn boton_estandar">{TituloBtn} </button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default SubirEditReglas